import { render, staticRenderFns } from "./Jump-Page-pc.vue?vue&type=template&id=293bc9d1&scoped=true"
import script from "./Jump-Page-pc.vue?vue&type=script&lang=js"
export * from "./Jump-Page-pc.vue?vue&type=script&lang=js"
import style0 from "./Jump-Page-pc.vue?vue&type=style&index=0&id=293bc9d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293bc9d1",
  null
  
)

export default component.exports